export const normalizeEndUser = (values) => {
    return {
        ...values,
        email: null,
    };
};

export const normalizeClientData = (values) => {

    return {
        mail: values.clientEmail,
        id : values.clientId

    };
};